/* Progressive enhancement: store list remains visible without JavaScript. */
(function(){
 function init(root){
  root.querySelectorAll('[data-wb-store-locator]').forEach(function(section){
   if(section.dataset.searchReady)return;
   section.dataset.searchReady='true';
   var input=section.querySelector('[data-store-search]');
   if(!input)return;
   var cards=Array.from(section.querySelectorAll('[data-store-grid] article'));
   var normalise=function(s){return s.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().trim();};
   section.querySelector('[data-store-search-wrap]').hidden=false;
   input.addEventListener('input',function(){
    var q=normalise(input.value), count=0;
    cards.forEach(function(card){var match=normalise(card.textContent).includes(q);card.hidden=!match;if(match)count++;});
    section.querySelector('[data-store-count]').textContent=count+(count===1?' punto vendita':' punti vendita');
    section.querySelector('[data-store-empty]').hidden=count!==0;
   });
  });
 }
 init(document);
 document.addEventListener('shopify:section:load',function(){init(document);});
})();
